import { Button, Container, Stack, Image, Text } from '@mantine/core';
import { signInWithPopup, onAuthStateChanged } from 'firebase/auth';
import { auth, googleProvider, db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useState, useEffect } from 'react';

export function Login() {
    const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsLoggedIn(!!user);
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []);

    const handleGoogleSignIn = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            // Check if user document exists
            const userDocRef = doc(db, 'users', user.uid);
            const userDoc = await getDoc(userDocRef);

            // If user document doesn't exist, create it with email
            if (!userDoc.exists()) {
                await setDoc(userDocRef, {
                    email: user.email,
                    createdAt: new Date().toISOString()
                });
            }
        } catch (error) {
            console.error('Error signing in with Google:', error);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(210deg, #60efff 0%, #0061ff 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Container size="sm" style={{ maxWidth: '16rem' }}>
                <Stack align="center" spacing="xl">
                    <Image
                        src={`${process.env.PUBLIC_URL}/logo_assets/dark_mode_with_shadow.png`}
                        alt="Stackly Logo"
                        width={80}
                    />
                    <Image
                        src={`${process.env.PUBLIC_URL}/stackly_cursive.png`}
                        alt="Stackly Cursive Logo"
                        width={200}
                    />
                    <Text size="lg" color="white" align="center" style={{ marginBottom: '1.5rem' }}>
                        Sort through chaos with one tidy stack to conquer your day.
                    </Text>
                    {isLoggedIn !== true && (
                        <Button
                            size="lg"
                            onClick={handleGoogleSignIn}
                            variant="filled"
                            color="light"
                            radius="xl"
                            loading={isLoggedIn === null}
                        >
                            Sign in with Google
                        </Button>
                    )}
                </Stack>
            </Container>
        </div>
    );
} 